import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatFeeEmployeejobModel } from 'src/app/model/cat-fee-employee-job-model';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CatFeeEmployeeJobService } from 'src/oldApp/services/cat-fee-employee-job.service';

@Component({
  selector: 'app-modal-fee-employee-job',
  templateUrl: './modal-fee-employee-job.component.html',
  styleUrls: ['./modal-fee-employee-job.component.css']
})
export class ModalFeeEmployeeJobComponent implements OnInit {
  @Input() fee:CatFeeEmployeejobModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=1;

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ<>=,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  ////////////////
  constructor(
    private modalService: NgbModal,
    private feeEmployeejobService:CatFeeEmployeeJobService,
    private employeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  updateMinFee=e=> this.fee.minFee=!e || e.trim()===''?null:Number(e);
  updateMaxFee=e=> this.fee.maxFee=!e || e.trim()===''?null:Number(e);
  toggleActive=()=> this.fee.activeId=!this.fee.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.minFeeError()) errors.push('Necesita capturar una cuota mínima.');
    if(this.maxFeeError()) errors.push('Necesita capturar una cuota máxima.');
    if(this.minFeeMayorError()) errors.push('La cuota mínima no puede ser mayor a la cuota máxima.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    console.log(this.fee)
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.fee.description=this.fee.description.toUpperCase();
      this.feeEmployeejobService.save(this.fee)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La cuota se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la cuota.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  descriptionError=()=> !this.fee.description || this.fee.description.trim()==='';
  employeeJobError=()=> !this.fee.employeeJobId;
  minFeeError=()=> this.fee.minFee!==0 && !this.fee.minFee;
  maxFeeError=()=> this.fee.maxFee!==0 && !this.fee.maxFee;
  minFeeMayorError=()=> this.fee.minFee > this.fee.maxFee; 

  // INFO
  getCatalogs=()=> {
    this.employeeJobService.getAll()
      .pipe(
        tap((resp:any)=> {
          if(resp) this.employeeJobCatalog=resp.data.filter(cat=> cat.employeeJobId===7);
          else throwError;
        }),
        catchError(error=> {
          console.log(error);
          this.close;
          return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
        })
      )
      .subscribe();
  }
}
